import {
  getTeamLabelByNumber,
  getDefaultStatisticItem
} from '../../utils/utils'

export default {
  statisticScheme: {
    'CORNER': getDefaultStatisticItem('statistic.hockey-ball.corners'),
    'PENALTY_TIME': getDefaultStatisticItem('statistic.hockey-ball.penalty_time')
  },
  statisticEvents: {
    'CORNER': 'CORNER_STROKE'
  },
  statisticOrder: [
    'CORNER',
    'PENALTY_TIME'
  ],
  statisticFunction (event, relatedEvent) {
    const eventForProcess = event.EventCode === 'CANCEL' ? relatedEvent : event
    const { EventCode, GamePeriod, TeamNumber } = eventForProcess
    const availableEventCodes = [
      '5_MIN_PENALTY',
      '5_MIN_PENALTY_WITHOUT_CHANGING_NUM_COMPOSITION',
      '10_MIN_PENALTY',
      '10_MIN_PENALTY_WITHOUT_CHANGING_NUM_COMPOSITION'
    ]

    if (!availableEventCodes.includes(EventCode)) {
      return
    }

    const updateType = event.EventCode === 'CANCEL' ? 'decrement' : 'increment'

    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'PENALTY_TIME',
      period: GamePeriod,
      team: getTeamLabelByNumber(TeamNumber),
      value: EventCode.includes('5_MIN_PENALTY') ? 5 : 10,
      type: updateType
    })
  },
  additionalStatisticBlocks: [
    {
      type: 'shootout',
      component: 'shootout-statistic'
    }
  ]
}
